import { Time } from "@angular/common";
import { DefaultReservationView, Status } from "../constants/commonenums";
import { CategoryDto } from "./CategoryModel";
import { ActivitySessionsDTO } from "./SessionBookingDTO";

export enum operationType {
  edit = 0,
  cancel = 1,
  create = 2
}

export class ColorDTO {
  public A: number;
  public R: number;
  public G: number;
  public B: number;
}

export interface PreReservationMessageDTO {
  Id?: number;
  PreReservationNotes: string;
  StartTime: string;
  EndTime: string;
}


export class SeatingAreaDTO {
  public Id: number;
  public Name: string;
  public Abbreviation: string;
  public Color?: ColorDTO;
}

export class SeatingTypesDTO {
  public Id: number;
  public Name?: string;
  public Abbreviation: string;
  public Color?: ColorDTO;
  public Description: string;
  public IsDeleted: boolean;
  public RestaurantId: number;
  public SeatingArea: SeatingAreaDTO[];
  public SeatingTypeSeatingAreaMappings: SeatingTypeSeatingAreaMappingDTO[];
}

export class SeatingTypeSeatingAreaMappingDTO {
  public Id: number;
  public SeatingAreaId: number;
  public SeatingTypeId: number;
}

export class CoverTypeQuantitiesDTO {
  public Id: number;
  public CoverTypeId: number;
  public Covers: number;
  public CoverTypeName: string;
}

export class BookingTypeQuantitiesDTO {
  public Id: number;
  public BookingTypeId: number;
  public BookingTypes: number;
  public BookingTypeName: string;
}
export class CoverTypePriceDTO {
  public Id: number;
  public Price: number;
  public CoverTypeName: string;
}

export class SpecialMealDTO {
  public ActivitySessions: ActivitySessionsDTO[];
  public Id: number;
  public Name: string;
  public IsPrepaymentRequired: boolean;
  public CoverTypePrices: CoverTypePriceDTO[];
  public ChargeOnBooking: boolean;
  public StartDate: Date;
  public EndDate: Date;
  public ShiftId: number;
  public Price: number;
  public WaiverFormCode: string;
  public SortOrder: number;
  public RestaurantId: number;
  public MinPartySize: number;
  public MaxPartySize: number;
  public SeatingAreaId: number;
  public DoesRequirePrepayment: boolean;
  public DeferredPaymentInDays: number;
  public CutOffMinutes: number;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public AvailableSlots: number = null;
  public ImageData: string;
  public CollectType?: CollectType;
  public CancellationPolicy: string = null;
  public ClassType: number;
  public LessonType: number;
  public FrequencyTypeIds?: [] = null;
  public WidgetPrePaymentMode: number;
}

export enum CollectType {
  CheckIn = 0,
  CheckOut = 1
}

export class CustomGuestFieldDTO {
  public Id: number = null;
  public MasterMerchantId: number = null;
  public FieldType: string = null;
  public FieldName: string = null;
  public FieldDescription: string = null;
  public IsCustomGuestFieldVisible: boolean = null;
  public FieldOptions: string = null;
  public MasterMerchant: MasterMerchant = null;
  public ContactCustomFields: any = null;
}
export class MasterMerchant implements IEntity, ITrackCreatedAtDateTime, ITrackUpdatedAtDateTime, INamedEntity {
  public Id: number;
  public Name: string;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public UseGuestScore: boolean;
  public GuestScoreVisits: number;
  public IntegrationTenantId: string;
  public Merchants: Merchant[];
  public Restaurants: any[];
  public Contacts: any[];
  public CustomGuestFields: any[];
}
export interface IEntity {
  Id: number;
}
export interface ITrackCreatedAtDateTime {
  CreatedAt: Date;
}
export interface ITrackUpdatedAtDateTime {
  UpdatedAt: Date;
}
export interface INamedEntity {
  Id: number;
  Name: string;
}
export interface IAuthenticatable extends IEntity {
  UserType: UserType;
  MerchantId: number;
  VerifyPassword(password: String, hashManager: IHashManager): boolean;
}
export enum UserType {
  Admin,
  MerchantUser,
  CRSUser
}
export interface IHashManager {
  GenerateSalt(): string;
  HashPassword(password: string, salt: string): string;
  VerifyPassword(password: string, hashedPass: string): boolean;
}
export interface IRestaurantEntity {
  RestaurantId: number;
}


export class Merchant implements IEntity, ITrackCreatedAtDateTime, ITrackUpdatedAtDateTime, INamedEntity {
  public Id: number;
  public Name: string;
  public MasterMerchantId: number;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public IsOnPremise: boolean;
  public LicenseKey: string;
  public EncryptedLicense: string;
  public MerchantUsers: MerchantUser[];
  public Restaurants: any[];
  public MasterMerchant: MasterMerchant;
}

export class ApnsToken implements IEntity, ITrackCreatedAtDateTime, ITrackUpdatedAtDateTime {
  public Id: number;
  public RestaurantId: number;
  public Token: String;
  public MerchantUserId: number;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public Restaurant: any;
  public MerchantUser: MerchantUser;
}

export class MerchantUser implements IEntity, INamedEntity, IAuthenticatable, ITrackCreatedAtDateTime, ITrackUpdatedAtDateTime {
  constructor() {
    this.MerchantUserRestaurants = {} as MerchantUserRestaurant[];
    this.ApnsTokens = {} as ApnsToken[];
  }
  public Id: number;
  public MerchantId: number;
  public IsSuperAdmin: boolean;
  public IsTrained: boolean;
  public Name: string;
  public Email: string;
  public EncryptedPassword: string;
  public PasswordSalt: string;
  public ResetPasswordToken: string;
  public ResetPasswordSentAt: Date;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public Merchant: Merchant;
  public MerchantUserRestaurants: MerchantUserRestaurant[];
  public ApnsTokens: ApnsToken[];
  public VerifyPassword(password: string, hashManager: IHashManager): boolean {
    return hashManager.VerifyPassword(password, this.EncryptedPassword);
  }
  public get UserType(): UserType {
    return UserType.MerchantUser;
  }
  // public GenerateResetPasswordToken(): void {
  //    this.ResetPasswordToken = PasswordHelper.GenerateAlphaNumericPassword(32);
  //    this.ResetPasswordSentAt = Date.UTC;
  // }
  public ClearResetPasswordToken(): void {
    this.ResetPasswordToken = null;
    this.ResetPasswordSentAt = null;
  }
}

export class MerchantUserRestaurant implements IEntity, IRestaurantEntity, ITrackCreatedAtDateTime, ITrackUpdatedAtDateTime {
  public Id: number;
  public MerchantUserId: number;
  public RestaurantId: number;
  public IsAdmin: boolean;
  public CreatedAt: Date;
  public UpdatedAt: Date;
  public MerchantUser: MerchantUser;
  public Restaurant: any;
}

export class CountryDTO {
  public Id: number;
  public Name: string;
  public CountryPhoneCode: string;
}

export class WidgetSettingsDTO {
  public RestaurantId: Number;
  public RestaurantName: string;
  public RestaurantUniqueName: string;
  public UseUnbrandedLayout: boolean;
  public PhoneNumber: string;
  public Street1: string;
  public Street2: string;
  public City: string;
  public State: string;
  public Country: string;
  public AvailableSpecialMeals: SpecialMealDTO[];
  public MealTabs: MealTabDTO[];
  public ShowMealTabs: boolean;
  public MaxPartySize: Number;
  public MaxAlternateDays: number;
  public AcceptsReservations: boolean;
  public DaysForReservation: Number;
  public InitialRemoteBookingTime: Date;
  public ReservationCutOffMinutes?: Number;
  public PreReservationMessage: string;
  public WidgetCustomization: WidgetCustomizationDTO;
  public UseDefaultWidgetCustomizations: boolean;
  public IsSmsReminderSupported: boolean;
  public IsGDPREnabled: boolean;
  public CustomPolicyText: string;
  public SlottingModeWidget: string;
  public UseMembershipNumber: boolean;
  public MembershipNumberName: string;
  public MerchantId: number;
  public OfflineStartTime?: Date;
  public OfflineEndTime?: Date;
  public DisableReservations: boolean;
  public CancellationTitle: string;
  public PropertyTypeId: Number;
  public ConfirmationVia: ConfirmationVia;
  public SeatingAreaList: SeatingAreaDTO[];
  public SeatingTypeList: SeatingTypesDTO[];
  public SeatingAreaSeatingTypeMappings: SeatingTypeSeatingAreaMappingDTO[];
  public DefaultWaiverForm: WaiverFormDTO;
  public PropertyType: string;
  public OperationCurrency: string;
  public PreferencesCategories: CategoryDto[];
  public MarketingFlagEnabled: boolean;
  public MarketingFlagHeader: string;
  public MarketingFlagDescription: string;
  public EnableMultiSlotSelection: boolean;
  public AllocationMappings: AllocationPropertyMappingDTO[];
  public TimeSlotUnitInMinutes: number;
  public MaxPastTimeForReservationsInMinutes: number;
  public DaylightDelta: string;
  public IsCartEnabled: boolean;
  public DateFormat: string;
  public customGuestFieldsMappingValidations: CustomGuestFieldsMappingDTO[];
  public Addons: AddonDTO[];
  public ShowAliasName:boolean;
  public NumberOfFractionalDigits: number = 2;
  public DisableCustomTermsAndConditions: boolean;
  public CopyPrimaryContactDetailsToSecondaryWidget: boolean;
  public ContactMinLength: number;
}

export class AddonDTO {
  AddonId: number;
  SelectionType: SelectionType;
  IsOpenbookingEnabled: boolean;
  AddonName: string;
  CategoryId: number;
  SubCategoryId: number;
  Description: string;
  AvailableforWebReservation: boolean;
  Quantity: number;
  RetailItemId: number;
  PricingCategory: PricingCategory;
  Duration: number;
  PricingType: PricingType
  Price: number;
  AdditionalPrice: number;
  AdditionalMinutes: number;
  ImageId: string;
  ImageFile: string;
  ImageChanged: string;
  RestaurantId: number;
  StatusMaster: Status;
  AddonActivitiesMappings: AddonActivitiesMappingsDTO[];
  selectedQuantity?: number;
}

export class AddonActivitiesMappingsDTO {
  MappingId: number;
  AddonId: number;
  ActivityId: number;
  AvailableForWebReservation: boolean;
  IsMandatory: boolean;
  IsCategoryLevelMandatory
  IsVisible: boolean;
  MinQuantity: number;
  MaxQuantity: number;
  ConsiderForAvailability: boolean;
}

export enum TaxType {
  Tax = 0,
  VAT = 1
}

export class AddOnAvailability{
  AddonId: number;
  SpecialMealId : number;
  AvailableQuantity: number;
  LockedQuantity: number;
  SoldQuantity: number;
  OverAllQuantity: number;
  IsUnlimited: boolean = false;
}

export enum SelectionType // addontype
{
  PerGuest = 1,
  PerBooking,
  PerLesson
}
export enum PricingCategory {
  BySession = 1,
  ByDuration
}

export enum PricingType {
  ByHour = 1,
  ByMinutes
}
export class CustomGuestFieldsMappingDTO {
  public ActivityId: number
  public CustomFields: CustomFields[] = [];
}
export class CustomFields {
  Id: number;
  public FieldId: number;
  public IsVisible: boolean;
  public AvailableForWebReservation: boolean;
  public Validations: ValidationType[] = [];
}
export class ValidationType {
  public Id: number;
  public SelectedValidationType: number;
  public TargetValue: string;
}

export class AllocationPropertyMappingDTO {
  public Id: number;
  public AllocationTypeId: number;
  public AllocationTypeName: string;
  public PropertyId: number;
  //public StatusCode: StatusMaster;
  public Color: ColorDTO;
  public BlockType: number;
}

export class WaiverFormDTO {
  public RestaurantId: Number;
  public FormCode: string;
  public Applied: boolean;
}

export enum ConfirmationVia {
  Email,
  Sms,
  Both
}

export class CommentCardCustomizationDTO {
  public PropertyId: Number;
  public HeaderFont: string;
  public HeaderBackground: string;
  public FooterBackground: string;
  public HeaderTextColor: string;
  public FooterTextColor: string;
  public CommentCardTextColor: string;
  public CommentCardBackgroundColor: string;
  public StarBackgroundColor: string;
  public ButtonLinkColor: string;
  public MainContentTextColor: string;
  public SurveyBackgroundColor: string;
}

export class WidgetCustomizationDTO {
  public Layout: string;
  public HeaderFont: string;
  public HeaderText: string;
  public HeaderStyle: string;
  public TopHalfBackgroundColor: string;
  public BottomHalfBackgroundColor: string;
  public AvailableButtonColor: string;
  public TitleTextColor: string;
  public BodyTextColor: string;
  public EarlierLaterLinkColor: string;
  public LineColor: string;
  public WidgetFooterLinkColor: string;
  public FooterBackgroundColor: string;
  public MaincontentTopBackgroundColor: string;
  public MaincontentBottomBackgroundColor: string;
  public SubheaderBackgroundColor: string;
  public SubheaderTextColor: string;
  public SubHeaderFontSize: string;
  public SubHeaderPosition: string;
  public SubHeaderFont: string;
  public SubHeaderText: string;
  public AvailableButtonHoverColor: string;
  public EarlierLaterHoverColor: string;
  public EarlierLaterHoverBackgroundColor: string;
  public WidgetFooterHoverColor: string;
  public FooterTextColor: string;
  public WidgetBorderColor: string;
  public WidgetLinkColor: string;
  public WidgetLinkHoverColor: string;
  public WidgetBackgroundColor: string;
  public UnavailableButtonBackgroundColor: string;
  public AvailableButtonHoverBackgroundColor: string;
  public AvailableButtonBackgroundColor: string;
  public WidgetExtraMessaging: string;
  public PartySizeAndDateDisclaimer: string;
  public CustomTermsOfService: string[];
  public ConfirmationMessage: string;
  public PreReservationMessage: string;
  public PreReservationMessages: PreReservationMessageDTO[];
  public CustomNoShowFeeTerms: string;
  public PromoCodeLabel: string;
  public CustomCssUrl: string;
  public CustomLayout: string;
  public HeaderFontSize: string;
  public LocationFilters: number[];
  public MainContentFont: string;
  public MainContentFontSize: string;
  public ButtonFont: string;
  public ButtonFontSize: string;
  public ButtonStyle: string;
  public InputStyle: string;
  public HyperlinkFont: string;
  public SpecialMealFont: string;
  public SpecialMealFontSize: string;
  public SMFontColor: string;
  public SMSelectedBackgroundColor: string;
  public SMBackgroundColor: string;
  public PrimaryButtonBGColor: string;
  public PrimaryButtonTextColor: string;
  public SecondaryButtonBGColor: string;
  public SecondaryButtonTextColor: string;
  public TimeSlotType: string;
  public ShowCommunalTableAvailabilityOption: boolean;
  public AllowTableSelection: boolean;
  public IsReservationReminderMandatory: boolean;
  public ConfirmationVia: ConfirmationVia;
  public AllowAdditionalGuestDetails: boolean;
  public AllowMultipleTableSelection: boolean;
  public GTMCode: string;
  public NotesType: number;
  public DisplayPromoCode: boolean;
  public AllowNewReservations: boolean;
  public DisplayRestaurantAddress: boolean;
  public DisplayRestaurantName: boolean;
  public RestaurantNameFont : string;
  public RestaurantNameSize : string;
  public RestaurantNameTextColor : string;
  public RestaurantAddressFont : string;
  public RestaurantAddressSize : string;
  public RestaurantAddressTextColor : string;
  public DisplayModifyButton : boolean;
  public DisplayCancelButton : boolean;
  public DefaultReservationView: DefaultReservationView;
}

export class MealTabDTO {
  public Id: Number
  public Name: string
  public StartTime: Date
  public EndTime: Date
}

export enum Language {
  'English' = 1,
  'ChineseSimplified' = 2,
  'ChineseTraditional' = 3,
  'Japanese' = 4,
  'Korean' = 5,
  'French' = 6
}

export enum LanguageFileName {
  'english' = 1,
  'chinesesimplified' = 2,
  'chinesetraditional' = 3,
   'japanese' = 4,
   'korean' = 5,
   'french'=6
}

export enum LanguageCode {
  'english' = 'en',
  'chinesesimplified' = 'zh-s',
  'chinesetraditional' = 'zh-t',
   'japanese' = 'ja',
   'korean' = 'ko',
   'french'= 'fr'
}

export class DataRetentionPolicy {
  public Id: number;

  public Tenantid: number;

  public EffectiveDate: Date;

  public CategoryId: number

  public PolicyType: PolicyType;

  public PolicyDetails: DataRetentionPolicyDetails[];
}

export enum PolicyType {
  Standard = 1,
  Consent = 2
}

export class DataRetentionPolicyDetails {
  public Id: number;

  public DataType: PolicyDataType;

  public RetentionInDays: number;

  public PolicyId: number

  public CreatedDate: Date;
}

export enum PolicyDataType {
  Name = 1,
  EmailAddress = 2,
  PhoneNumber = 3,
  Address = 4,
  GuestImage = 5,
  BirthdayAndAnniversary = 6,
  CustomGuestFields = 7
}

export enum SlottingMode {
  Manual,
  Automatic
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export class WidgetActivitiesFilterDTO {
  public LocationId: number;
  public InstructorId: number;
  public StartDate: Date;
  public EndDate: Date;
  public StartTime: Time;
  public EndTime: Time;
  public filteredDays: DayOfWeek[];
}

